export interface SmsLogParams {
  search?: string;
  row?: number;
  fetch?: number;
  fromDate?: number;
  toDate?: number;
}

export enum SMS_STATUS {
  PENDING = 'P',
  SENT = 'S',
}

export interface SmsLog {
  smsLogId: string;
  phoneNumber: string;
  message: string;
  createdOn: number;
  createdDate?: number;
  status: SMS_STATUS;
  nickname: string;
}
